'use strict';
define([
    "dojo/_base/declare",
    "mw-filebrowser/actions/Action",
    "mw-keybindings/DefaultKeys",
    "dojo/keys",
    "mw-filename-utils/FileNameUtil",
    "util",
    "dojo/i18n!nls/mldoStringResource",
    "dojo/string"
], function (declare, Action, DefaultKeys, keys, FileNameUtil, Util, MLDOStrings, DojoString) {
  return declare(Action, {
    constructor: function (args) {
        args = args || {};
        let context = args.context;
        let makeActionAvailable = args.showAction || false;
        this.sharingEnabled = args.isSharingEnabled || false;
        this.name = "deleteAction";
        this.label = MLDOStrings.contextMenuDeleteLabel;
        this.enabled = makeActionAvailable;
        this.section = {
            id: "MISC",
            name: "MISC",
            allowSubMenu: false,
            forceSubMenu: false
        };
        this.keyCode = keys.DELETE;
        this.shortcut = "Delete";
        this.supportsKeyBinding = true;
        this.isApplicableTo = function (path) {
          let selectedFileCount = context.getSelectedRowCount();
          let parentWritable = true;
          if (selectedFileCount < 1) {
            this.enabled = false;
          } else {
            let fileInfos = context.getSelectedItemFileInfos();
            let fileInfo;
            for (let i = 0; i < fileInfos.length; i++) {
              fileInfo = fileInfos[i];
              if (!fileInfo.filePermissions.parentCanWrite) {
                parentWritable = false;
              }
            }
            this.enabled = makeActionAvailable && parentWritable && FileNameUtil.isFileInfo(fileInfo);
          }
          return this.enabled;
        };
        this.callback = function (action) {
          let fileInfos = context.getSelectedItemFileInfos();
          let sortedFileInfos = Util.sortFileInfosByPath(fileInfos);
          let fileInfo = fileInfos[0];
          let currentFolder = context.getCurrentFolder();
          let path = FileNameUtil.pathFromFileInfo(fileInfo);
          if (currentFolder !== "/") {
              path = currentFolder + path;
          }
          if (this.isApplicableTo()) {
            if (fileInfos.length === 1 && fileInfo && path) {
              context.handleDeleteAction(path, fileInfo);
            } else if (fileInfos.length > 1) {
              context.handleMultiSelectDelete(sortedFileInfos, 0, 0);
            }
          }
        };
    }
  });

});
